export default __webpack_public_path__ + "static/media/asset-detail-iv-audio-added.e7709760.png";